module.exports = __webpack_public_path__ + "media/images/lb/751-5dcffd9e9cac72ec650c572fe247b88e.svg";